// extracted by mini-css-extract-plugin
module.exports = {"h1":"h1-2Tq","h2":"h2-20S","h3":"h3-2Fl","h4":"h4-1iM","h5":"h5-1Lz","underline":"underline-3tF"};